"use strict";
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
Object.defineProperty(exports, "__esModule", { value: true });
const configs_1 = require("../configs");
const lodash_1 = require("lodash");
const base = (rest) => `${configs_1.configuration.api}/${rest}`;
const publicBase2v = (rest) => `${configs_1.configuration.api2v}/public/${rest}`;
const portalBase2v = (rest) => `${configs_1.configuration.api2v}/portal/${rest}`;
const rightsholderBase2v = (ipId, rest) => `${configs_1.configuration.api2v}/rightsholder/${ipId}${rest ? `/${rest}` : ''}`;
const songwriterBase2v = (ipId, rest) => `${configs_1.configuration.api2v}/songwriter/${ipId}${rest ? `/${rest}` : ''}`;
const paginationPath = (pagination) => {
    if (pagination) {
        return `?page=${pagination.page}&limit=${pagination.limit}${pagination.source ? `&source=${pagination.source}` : ''}`;
    }
    else {
        return;
    }
};
const paginationPath2v = (pagination) => `?page=${pagination.page ? pagination.page - 1 : 1}&size=${pagination.limit}${pagination.source ? `&source=${pagination.source}` : ''}`;
const paginationSearchPath = (pagination) => {
    if (pagination) {
        return `?page=${pagination.page}&limit=${pagination.limit}${pagination.refined ? `&refined` : ''}`;
    }
    else {
        return;
    }
};
const paginationUserPath = (pagination) => {
    if (pagination && !pagination.group) {
        return `?page=${pagination.page}&limit=${pagination.limit}`;
    }
    else if (pagination) {
        return `?page=${pagination.page}&limit=${pagination.limit}&group=${pagination.group}`;
    }
    else {
        return;
    }
};
const applyMultiSort = (url, pagination) => {
    if (pagination) {
        const sortToApply = (0, lodash_1.isArray)(pagination.sort) ? pagination.sort : [pagination.sort];
        sortToApply.forEach((item) => {
            var _o;
            if ((item === null || item === void 0 ? void 0 : item.field) !== undefined) {
                const sort = item;
                url.searchParams.append('sort', `${sort.field},${(_o = sort.direction) !== null && _o !== void 0 ? _o : 'asc'}`);
            }
        });
    }
};
class Pathes {
}
Object.defineProperty(Pathes, "Auth", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (_a = class {
        },
        __setFunctionName(_a, "Auth"),
        Object.defineProperty(_a, "signIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('security/token')
        }),
        Object.defineProperty(_a, "mfaSubmit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('security/mfa-confirm')
        }),
        Object.defineProperty(_a, "logOut", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('security/logout')
        }),
        Object.defineProperty(_a, "forgotPassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('security/forgot-password')
        }),
        Object.defineProperty(_a, "confirmForgotPassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('security/confirm-forgot-password')
        }),
        _a)
});
Object.defineProperty(Pathes, "User", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (_b = class {
        },
        __setFunctionName(_b, "User"),
        Object.defineProperty(_b, "userInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('user/me')
        }),
        Object.defineProperty(_b, "userSetSetting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('user/setting')
        }),
        Object.defineProperty(_b, "userEnable2fa", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('user/enable-2fa')
        }),
        Object.defineProperty(_b, "userGetSettings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('user/settings')
        }),
        Object.defineProperty(_b, "createUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('user/registration')
        }),
        Object.defineProperty(_b, "attemptKyc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (userExposedId) => publicBase2v(`user/${userExposedId}/kyc/attempt`)
        }),
        Object.defineProperty(_b, "attemptKycAuth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (userExposedId) => portalBase2v(`user/${userExposedId}/kyc/attempt`)
        }),
        Object.defineProperty(_b, "activateUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (activationCode) => base(`user/activation-code/${activationCode}`)
        }),
        Object.defineProperty(_b, "sendResetPasswordCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('security/user-password-validate')
        }),
        Object.defineProperty(_b, "userPassChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('security/user-password-change')
        }),
        Object.defineProperty(_b, "resetMfa", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (userId) => base(`user/${userId}/reset-mfa`)
        }),
        _b)
});
Object.defineProperty(Pathes, "Notification", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (_c = class {
        },
        __setFunctionName(_c, "Notification"),
        Object.defineProperty(_c, "token", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => portalBase2v('notification/token')
        }),
        _c)
});
Object.defineProperty(Pathes, "RightsHolder", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (_d = class {
        },
        __setFunctionName(_d, "RightsHolder"),
        Object.defineProperty(_d, "rightsHolders", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('rightsholders')
        }),
        Object.defineProperty(_d, "memberList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: portalBase2v('members')
        }),
        Object.defineProperty(_d, "createRightsHolder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: portalBase2v('rightsholder')
        }),
        Object.defineProperty(_d, "newRightsholderQuestionnaire", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: portalBase2v('questions')
        }),
        Object.defineProperty(_d, "getRelatedRightsholders", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => portalBase2v(`rightsholder/related`)
        }),
        Object.defineProperty(_d, "verifyRightsholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (hfaPublisherNumber) => portalBase2v(`rightsholder/verify/${hfaPublisherNumber}`)
        }),
        Object.defineProperty(_d, "editRightsHolder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => rightsholderBase2v(rightsholderId)
        }),
        Object.defineProperty(_d, "rightsHolderSummary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => rightsholderBase2v(rightsholderId, 'summary')
        }),
        Object.defineProperty(_d, "rightsholderContact", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => rightsholderBase2v(rightsholderId, 'contact')
        }),
        Object.defineProperty(_d, "rightsholderContacts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => rightsholderBase2v(rightsholderId, 'contacts')
        }),
        Object.defineProperty(_d, "rightsholderContactById", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, contactId) => rightsholderBase2v(rightsholderId, `contact/${contactId}`)
        }),
        Object.defineProperty(_d, "rightsHolderUsers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => base(`rightsholder/${rightsholderId}/users`)
        }),
        Object.defineProperty(_d, "rightsHolderUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, userId) => base(`rightsholder/${rightsholderId}/user/${userId}`)
        }),
        Object.defineProperty(_d, "actionRightsHolderUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => base(`rightsholder/${rightsholderId}/user`)
        }),
        Object.defineProperty(_d, "tipaltiIframeUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, payeeIpId) => rightsholderBase2v(rightsholderId, `payees/${payeeIpId}/iframe`)
        }),
        Object.defineProperty(_d, "claimedShares", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => base(`rightsholder/${rightsholderId}/works/shares`)
        }),
        // statements "pathes"
        Object.defineProperty(_d, "dspRates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (year, month, dsp) => portalBase2v(`statements/rates/v2/years/${year}/months/${month}${dsp ? `/dsps/${dsp}` : ''}`)
        }),
        Object.defineProperty(_d, "ratePeriods", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => portalBase2v('statements/rates/v2/usageperiods')
        }),
        Object.defineProperty(_d, "rateDsps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => portalBase2v('statements/rates/v2/dsps')
        }),
        Object.defineProperty(_d, "rateSheetDownload", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (downloadLink) => portalBase2v(downloadLink)
        }),
        Object.defineProperty(_d, "royalties", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, year, month) => rightsholderBase2v(rightsholderId, `statements/payees/years/${year}${month ? `/months/${month}` : ''}`)
        }),
        Object.defineProperty(_d, "payeeActivityDownload", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (pasLink) => portalBase2v(pasLink)
        }),
        Object.defineProperty(_d, "latestRoyalties", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => rightsholderBase2v(rightsholderId, 'statements/options')
        }),
        Object.defineProperty(_d, "payeeOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => rightsholderBase2v(rightsholderId, 'statements/payees/options')
        }),
        Object.defineProperty(_d, "allPayees", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => rightsholderBase2v(rightsholderId, 'payees')
        }),
        Object.defineProperty(_d, "statements", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, payee) => rightsholderBase2v(rightsholderId, `statements/payees/${payee}`)
        }),
        Object.defineProperty(_d, "tsvRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => rightsholderBase2v(rightsholderId, 'statements/request')
        }),
        Object.defineProperty(_d, "annualTSVRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => rightsholderBase2v(rightsholderId, 'statements/request/annual')
        }),
        Object.defineProperty(_d, "distributionSummary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, year, month) => rightsholderBase2v(rightsholderId, `report/summary/link?year=${year}${month ? `&month=${month}` : ''}`)
        }),
        // processing analytics
        Object.defineProperty(_d, "paymentsYTD", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => rightsholderBase2v(rightsholderId, `processing/analytics/paid/yeartodate`)
        }),
        Object.defineProperty(_d, "paymentsLastDistribution", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => rightsholderBase2v(rightsholderId, `processing/analytics/paid/lastdistribution`)
        }),
        Object.defineProperty(_d, "paymentsForDistributions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, distributionCount) => rightsholderBase2v(rightsholderId, `processing/analytics/paid/period/${distributionCount}`)
        }),
        // unmatched "pathes"
        Object.defineProperty(_d, "unclaimedSearch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (pagination) => base(`search/matching${paginationSearchPath(pagination)}&unclaimed=true`)
        }),
        Object.defineProperty(_d, "unmatchedSearch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (queryString) => base(`dsp-recording?${queryString}`)
        }),
        Object.defineProperty(_d, "dspRecordingDetails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (recordingId) => base(`dsp-recording/${recordingId}`)
        }),
        Object.defineProperty(_d, "dspRecordingsForSongCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (songCode, pagination, order = 'matchedAmount') => base(`dsp-recording/matched/${songCode}${paginationPath(pagination)}&order=${order}&direction=desc`)
        }),
        Object.defineProperty(_d, "createMatchSuggestion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => base(`dsp-recording/rightsholder/${rightsholderId}/suggested-matches`)
        }),
        Object.defineProperty(_d, "matchSuggestions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, statuses, sort, pagination) => {
                var _o, _p;
                const url = new URL(rightsholderBase2v(rightsholderId, 'matching/suggestions'));
                url.searchParams.append('sort', sort + ',desc');
                statuses.forEach((status) => url.searchParams.append('status', status));
                if (pagination) {
                    url.searchParams.append('size', ((_o = pagination.limit) !== null && _o !== void 0 ? _o : 10).toString());
                    url.searchParams.append('page', ((_p = pagination.page) !== null && _p !== void 0 ? _p : 1).toString());
                }
                return url.toString();
            }
        }),
        Object.defineProperty(_d, "singleMatchSuggestion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, suggestionId) => rightsholderBase2v(rightsholderId, `matching/suggestions/${suggestionId}`)
        }),
        Object.defineProperty(_d, "recordingGroupDetails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, suggestionId, recordingGroupStatus, pagination) => {
                var _o, _p;
                const url = new URL(rightsholderBase2v(rightsholderId, `matching/suggestions/${suggestionId}/recording_groups`));
                recordingGroupStatus.forEach((thisStatus) => url.searchParams.append('status', thisStatus));
                if (pagination) {
                    url.searchParams.append('size', ((_o = pagination.limit) !== null && _o !== void 0 ? _o : 10).toString());
                    url.searchParams.append('page', ((_p = pagination.page) !== null && _p !== void 0 ? _p : 1).toString());
                }
                return url.toString();
            }
        }),
        Object.defineProperty(_d, "matchSummary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => rightsholderBase2v(rightsholderId, `matching/summary`)
        }),
        // Overclaim "pathes"
        Object.defineProperty(_d, "overclaimViewByHeaderId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (overclaimHeaderId, rightsholderId) => rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}`)
        }),
        Object.defineProperty(_d, "overclaimHistoryByHeaderId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (overclaimHeaderId, rightsholderId) => rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/history`)
        }),
        Object.defineProperty(_d, "overclaimStatusCounts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => rightsholderBase2v(rightsholderId, 'search/overclaims/status-counts')
        }),
        Object.defineProperty(_d, "sendOverclaimEmail", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (overclaimHeaderId, rightsholderId) => rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/email`)
        }),
        Object.defineProperty(_d, "renderOverclaimEmailTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (overclaimHeaderId, rightsholderId) => rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/email-template`)
        }),
        Object.defineProperty(_d, "amendOverclaimShares", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (overclaimHeaderId, rightsholderId) => rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/amend`)
        }),
        Object.defineProperty(_d, "createRelinquishment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, overclaimHeaderId) => rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/create-relinquishment`)
        }),
        Object.defineProperty(_d, "getRelinquishments", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, overclaimHeaderId) => rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/relinquishments`)
        }),
        // Overclaim Document Upload "paths"
        Object.defineProperty(_d, "uploadDocumentForOverclaim", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, overclaimHeaderId) => rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/upload`)
        }),
        Object.defineProperty(_d, "updateOverclaimDocumentDescription", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, overclaimHeaderId, overclaimMemberUploadId) => rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/upload/${overclaimMemberUploadId}`)
        }),
        Object.defineProperty(_d, "getOverclaimUploadDocumentDownload", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, overclaimId, overclaimHeaderId) => rightsholderBase2v(rightsholderId, `overclaim/${overclaimId}/upload/${overclaimHeaderId}/download`)
        }),
        _d)
});
Object.defineProperty(Pathes, "Report", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (_e = class {
        },
        __setFunctionName(_e, "Report"),
        Object.defineProperty(_e, "formats", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (type) => portalBase2v(`report/${type}/formats`)
        }),
        Object.defineProperty(_e, "export", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, exportType) => rightsholderBase2v(rightsholderId, `report/${exportType}`)
        }),
        Object.defineProperty(_e, "songwriterExport", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (songwriterId, exportType) => songwriterBase2v(songwriterId, `report/${exportType}`)
        }),
        _e)
});
Object.defineProperty(Pathes, "Search", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (_f = class {
        },
        __setFunctionName(_f, "Search"),
        Object.defineProperty(_f, "searchWorks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (pagination) => {
                var _o;
                const url = new URL(publicBase2v(`search/works`));
                if (pagination) {
                    url.searchParams.append('size', ((_o = pagination.limit) !== null && _o !== void 0 ? _o : 10).toString());
                    url.searchParams.append('page', (pagination.page ? pagination.page - 1 : 0).toString());
                }
                return url.toString();
            }
        }),
        Object.defineProperty(_f, "searchWorksRH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, pagination) => {
                var _o;
                const url = new URL(rightsholderBase2v(rightsholderId, 'search/works/catalog'));
                if (pagination) {
                    url.searchParams.append('size', ((_o = pagination.limit) !== null && _o !== void 0 ? _o : 10).toString());
                    url.searchParams.append('page', (pagination.page ? pagination.page - 1 : 0).toString());
                    applyMultiSort(url, pagination);
                }
                return url.toString();
            }
        }),
        Object.defineProperty(_f, "searchWorksRHSuggestions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, property, searchTerm) => new URL(rightsholderBase2v(rightsholderId, `search/works/catalog/suggestions?property=${property}&searchTerm=${searchTerm}`)).toString()
        }),
        Object.defineProperty(_f, "searchOverclaimsRH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, pagination) => {
                var _o;
                const url = new URL(rightsholderBase2v(rightsholderId, 'search/overclaims'));
                if (pagination) {
                    url.searchParams.append('size', ((_o = pagination.limit) !== null && _o !== void 0 ? _o : 10).toString());
                    url.searchParams.append('page', (pagination.page ? pagination.page - 1 : 0).toString());
                    applyMultiSort(url, pagination);
                }
                return url.toString();
            }
        }),
        Object.defineProperty(_f, "searchOverclaimsRHSuggestions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, property, searchTerm) => new URL(rightsholderBase2v(rightsholderId, `search/overclaims/suggestions?property=${property}&searchTerm=${searchTerm}`)).toString()
        }),
        Object.defineProperty(_f, "searchWorksForPublisher", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (publisherIpId, pagination) => {
                var _o;
                const url = new URL(publicBase2v(`search/works/publisher/${publisherIpId}`));
                if (pagination) {
                    url.searchParams.append('size', ((_o = pagination.limit) !== null && _o !== void 0 ? _o : 10).toString());
                    url.searchParams.append('page', (pagination.page ? pagination.page - 1 : 0).toString());
                    applyMultiSort(url, pagination);
                }
                return url.toString();
            }
        }),
        Object.defineProperty(_f, "searchWorksHistoryRH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, registrationStatus, pagination, sort) => {
                const sortString = sort ? `&sort=${sort},desc&sort=master_transaction_id,desc` : '';
                return rightsholderBase2v(rightsholderId, `search/registration-history${paginationPath2v(pagination)}&status=${registrationStatus}` + sortString);
            }
        }),
        Object.defineProperty(_f, "searchWorksDraftsRH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, pagination) => base(`search/rightsholder/${rightsholderId}/works/drafts${paginationPath(pagination)}`)
        }),
        Object.defineProperty(_f, "searchUsers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, pagination) => base(`search/rightsholder/${rightsholderId}/users${paginationUserPath(pagination)}`)
        }),
        Object.defineProperty(_f, "searchWriters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (pagination) => {
                var _o;
                const url = new URL(publicBase2v(`search/works/writers`));
                if (pagination) {
                    url.searchParams.append('size', ((_o = pagination.limit) !== null && _o !== void 0 ? _o : 10).toString());
                    url.searchParams.append('page', (pagination.page ? pagination.page - 1 : 0).toString());
                }
                return url.toString();
            }
        }),
        Object.defineProperty(_f, "searchPublishers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (pagination) => {
                var _o;
                const url = new URL(publicBase2v(`search/works/publishers`));
                if (pagination) {
                    url.searchParams.append('size', ((_o = pagination.limit) !== null && _o !== void 0 ? _o : 10).toString());
                    url.searchParams.append('page', (pagination.page ? pagination.page - 1 : 0).toString());
                }
                return url.toString();
            }
        }),
        Object.defineProperty(_f, "searchPublishersForRH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsHolderId, pagination) => base(`search/${rightsHolderId}/publisher${paginationPath(pagination)}`)
        }),
        Object.defineProperty(_f, "searchSuggestions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (property, searchTerm, notClaimedBy, isOverclaimable) => {
                const url = new URL(publicBase2v(`search/works/suggestions?property=${property}&searchTerm=${searchTerm}`));
                if (notClaimedBy) {
                    url.searchParams.append('notClaimedBy', notClaimedBy);
                }
                if (isOverclaimable !== undefined) {
                    url.searchParams.append('isOverclaimable', isOverclaimable.toString());
                }
                return url.toString();
            }
        }),
        _f)
});
Object.defineProperty(Pathes, "Work", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (_g = class {
        },
        __setFunctionName(_g, "Work"),
        Object.defineProperty(_g, "worksHistoryRH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, pagination) => base(`rightsholder/${rightsholderId}/works/history${paginationPath(pagination)}`)
        }),
        Object.defineProperty(_g, "worksDraftsRH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, pagination) => base(`rightsholder/${rightsholderId}/works/drafts${pagination ? paginationPath(pagination) : ''}`)
        }),
        Object.defineProperty(_g, "workDraftRH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (draftId) => base(`drafts/${draftId}`)
        }),
        Object.defineProperty(_g, "postWork", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => base(`rightsholder/${rightsholderId}/work`)
        }),
        Object.defineProperty(_g, "workById", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (workId, rightsHolderId) => base(`work/${rightsHolderId}/${workId}/summary`)
        }),
        Object.defineProperty(_g, "submissionById", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (workId, rightsholderId) => rightsholderBase2v(rightsholderId, `transaction/${workId}`)
        }),
        Object.defineProperty(_g, "summaryById", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (workId, rightsHolderId) => base(`rightsholders/${rightsHolderId}/catalog/${workId}/summary`)
        }),
        Object.defineProperty(_g, "catalogWorkById", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (workId) => base(`catalog/work/${workId}`)
        }),
        Object.defineProperty(_g, "createWriter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('writer')
        }),
        _g)
});
Object.defineProperty(Pathes, "Lib", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (_h = class {
        },
        __setFunctionName(_h, "Lib"),
        Object.defineProperty(_h, "langs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('lib/languages')
        }),
        Object.defineProperty(_h, "countries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('lib/countries')
        }),
        Object.defineProperty(_h, "writerRoles", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('lib/writer-roles')
        }),
        Object.defineProperty(_h, "akaTitleTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('lib/aka-title-types')
        }),
        _h)
});
Object.defineProperty(Pathes, "Upload", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (_j = class {
        },
        __setFunctionName(_j, "Upload"),
        Object.defineProperty(_j, "files", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (pagination, rightsholderId) => base(`upload/${rightsholderId}/file${paginationPath(pagination)}`)
        }),
        Object.defineProperty(_j, "works", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId, file) => base(`upload/${rightsholderId}/works${file ? `/${file}` : ''}`)
        }),
        Object.defineProperty(_j, "downloadTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: `${configs_1.configuration.simple}/MLCBulkWork_V1.2.xlsx`
        }),
        _j)
});
Object.defineProperty(Pathes, "Songwriter", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (_k = class {
        },
        __setFunctionName(_k, "Songwriter"),
        Object.defineProperty(_k, "list", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: portalBase2v('songwriter')
        }),
        Object.defineProperty(_k, "summary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => songwriterBase2v(id)
        }),
        Object.defineProperty(_k, "writerSearch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (pagination, id) => {
                var _o;
                const url = new URL(songwriterBase2v(id, 'writer/search'));
                if (pagination) {
                    url.searchParams.append('size', ((_o = pagination.limit) !== null && _o !== void 0 ? _o : 10).toString());
                    url.searchParams.append('page', (pagination.page ? pagination.page - 1 : 0).toString());
                }
                return url.toString();
            }
        }),
        Object.defineProperty(_k, "writerLinkSearch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => songwriterBase2v(id, 'writerLink/search')
        }),
        Object.defineProperty(_k, "linkWriter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, writerIpId) => songwriterBase2v(id, `writer/${writerIpId}`)
        }),
        Object.defineProperty(_k, "searchSongwriterCatalog", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, pagination) => {
                var _o, _p, _q;
                const url = new URL(songwriterBase2v(id, 'catalog/search'));
                if (pagination) {
                    url.searchParams.append('size', ((_o = pagination.limit) !== null && _o !== void 0 ? _o : 10).toString());
                    url.searchParams.append('page', (pagination.page ? pagination.page - 1 : 0).toString());
                    if (((_p = pagination.sort) === null || _p === void 0 ? void 0 : _p.field) !== undefined) {
                        const sort = pagination.sort;
                        url.searchParams.append('sort', `${sort.field},${(_q = sort.direction) !== null && _q !== void 0 ? _q : 'asc'}`);
                    }
                }
                return url.toString();
            }
        }),
        Object.defineProperty(_k, "searchSongwriterCatalogSuggestions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, property, searchTerm) => new URL(songwriterBase2v(id, `catalog/search/suggestions?property=${property}&searchTerm=${searchTerm}`)).toString()
        }),
        _k)
});
Object.defineProperty(Pathes, "Support", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (_l = class {
        },
        __setFunctionName(_l, "Support"),
        Object.defineProperty(_l, "support", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('support')
        }),
        Object.defineProperty(_l, "helpForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: base('support/contact-us')
        }),
        _l)
});
Object.defineProperty(Pathes, "Public", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (_m = class {
        },
        __setFunctionName(_m, "Public"),
        Object.defineProperty(_m, "contacts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (ipIds) => publicBase2v(`contacts/${ipIds}`)
        }),
        _m)
});
exports.default = Pathes;
